module.exports = __webpack_public_path__ + "static/media/cotton.f196214a.jpeg";